import { gql } from "@apollo/client";

export const EMERGENCY_STOP_SYSTEM = gql`
mutation EmergencyStop($domain: String!, $systemId: Int!) {
  system {
    emergencyStop(domain: $domain, systemId: $systemId) {
      code
      message
      success
      id
    }
  }
}
`

export interface EmergencyStopSystemInput {
  system_id: number;
  domain: string;
}

interface SystemEmergencyStopResponse {
  code: string;
  message: string;
  success: boolean;
  id: Number
}

export interface EmergencyStopSystemResponse {
  system: {
    emergencyStop: SystemEmergencyStopResponse; 
  }
}